export const removeFeedbackMessageHighlight = (className: string) => {
  const highlightedMessageElements = document.querySelectorAll(
    `#feedback-details .${className}`,
  );
  highlightedMessageElements.forEach((message) => {
    message.classList.remove(className);
  });
};
